import WorkLogForm from "../workLogForm";
import { coreDrills, soilTypes, surfaces, utilityTypes } from "./potholingForm";
//--------------------------------------------------------------------------------------------
export default function TestPotholingForm({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Date", type: "date", required: true}, 
        {title: "Potholing Number", type: "text", required: true}, 
        {title: "Cancel", type: "radio", required: true}, 
        {title: "Type of Surface", type: "select", options: surfaces, required: true, parentNo: "Cancel"}, 
        {title: "Soil Type", type: "select", options: soilTypes, required: true, parentNo: "Cancel"}, 
        {title: "Core Drill", type: "select", options: coreDrills, required: true, parentNo: "Cancel"}, 
        {title: "Utility Type", type: "select", options: utilityTypes, required: true, suffix: <span className = "ml-2 text-info">Let us know if your choice is not included.</span>, parentNo: "Cancel"}, 
        {title: "Utility Material", type: "text", required: true, parentNo: "Cancel"}, 
        {title: "Dry Hole?", type: "radio", required: true, parentNo: "Cancel"}, 
        {title: "Utility in Duct?", type: "radio", required: true, parentNo: "Cancel"}, 
        {title: "Utility Duct Width", type: "number", required: true, parentNo: "Cancel", parentNo2: "Dry Hole?", suffix: <span className = "ml-2">inches</span>}, 
        {title: "Pothole Diameter", type: "number", required: true, suffix: <span className = "ml-2">inches</span>, parentNo: "Cancel"}, 
        {title: "Pavement Thichness", type: "number", required: true, suffix: <span className = "ml-2">inches</span>, parentNo: "Cancel"}, 
        {title: "Swing Tie 1", type:"text", required: true, parentNo: "Cancel"}, 
        {title: "Swing Tie 2", type:"text", required: true, parentNo: "Cancel"}, 
        {title: "Swing Tie 3", type:"text", required: true, parentNo: "Cancel"}, 
        {title: "Notes", type: "textarea", required: true}
        // Traverse View
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <WorkLogForm
            picsLimit = {6}
            items = {items}
            {...rest}
        />
    )    
}